import { TStandardSectionStep } from 'models';
import { AxiosError } from 'axios';
import { useApp } from 'context/App';
import { errorNotification, translate } from 'utils';
import {
  DrawerControlsRow,
  DrawerControlsRowControl,
  DrawerControlsRowControlIcon, DrawerControlsRowControlLabel
} from './styles';
import { DefaultIcon } from 'styles/common';
import React from 'react';

const ControlsRow = ({
  step,
  updateStep,
  onUserDelete,
  userId,
  userAdditionalControl,
  readOnly,
}: {
  step: TStandardSectionStep,
  updateStep: (step: string) => void,
  onUserDelete: (userId: string, onError: (error: AxiosError) => void) => void,
  userId: string,
  userAdditionalControl?: JSX.Element,
  readOnly?: boolean,
}) => {

  const { showNotification, showDialog } = useApp();

  const onError = (error: AxiosError) => {
    errorNotification(error, showNotification, false, 'quote');
  };

  return (
    <DrawerControlsRow>
      {step === 'profile' ? (
        <DrawerControlsRowControl onClick={!readOnly ? () => {
          showDialog({
            body: translate({ key: 'dialog.remove_customer.body' }),
            buttonAccept: <>
              {translate({ key: 'dialog.remove_customer.accept' })}&nbsp;
              <DefaultIcon icon="trash" />
            </>,
            buttonDecline: translate({ key: 'common.cancel' }),
            onAccept: () => onUserDelete(userId, onError),
          });
        } : undefined}>
          <DrawerControlsRowControlIcon margin="right" icon="remove" />
          <DrawerControlsRowControlLabel>{translate({ key: 'customer.delete_profile' })}</DrawerControlsRowControlLabel>
        </DrawerControlsRowControl>
      ) : (
        <DrawerControlsRowControl onClick={!readOnly ? () => updateStep(`profile/${userId}/summary`) : undefined}>
          <DrawerControlsRowControlIcon margin="right" icon="profile_card" />
          <DrawerControlsRowControlLabel>{translate({ key: 'customer.show_profile' })}</DrawerControlsRowControlLabel>
        </DrawerControlsRowControl>
      )}
      {userAdditionalControl}
    </DrawerControlsRow>
  );
};

export default ControlsRow;
